window.o_global = window.o_global || {};
window.AS = window.AS || {};
window.o_util = window.o_util || {};
